<app-whatsapp-button></app-whatsapp-button>
<!-- CADASTRO -->
<div class="container">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-4">
      <h1 *ngIf="edit">Atualizar cadastro</h1>
      <h1 *ngIf="!edit">Cadastre-se</h1>
      <p>{{register}}</p>
    </div> <!-- /col -->
  </div> <!-- /row -->

  <div class="row justify-content-center">
    <div class="col-12 col-lg-6">

      <div class="form-panel form-panel-lg" [ng2-loading]="showSpinner">

        <!-- <h2>Cadastre-se</h2> -->

        <form (ngSubmit)="f.form.valid && efetuarCadastro()" #f="ngForm">
          <div class="form-group" [ngClass]="{ 'invalid': (fullName.invalid && fullName.touched) || (fullName.invalid && f.submitted) }">
            <label for="fullName">Nome</label>
            <input type="text" class="form-control" id="fullName" name="fullName" [(ngModel)]="model.fullName"
              #fullName="ngModel" required>
          </div>

          <div class="form-group" [ngClass]="{ 'invalid': birthDate.invalid && birthDate.touched }">
            <label>Data de Nascimento</label>
            <input type="text" #birthDate="ngModel" class="form-control" id="birthDate" name="birthDate" (ngModelChange)="alterarData($event)" [(ngModel)]="model.birthDate2" [textMask]="{mask: datamask}" placeholder="__/__/____" required>
          </div>

          <div class="form-group" [ngClass]="{ 'invalid': (cpf.invalid && cpf.touched) || (cpf.invalid && f.submitted) }">
            <label for="cpf">CPF</label>
            <input [textMask]="{mask: cpfmask}" placeholder="___.___.___-__" type="text" class="form-control" id="cpf" name="cpf" [(ngModel)]="model.cpf" #cpf="ngModel" required>
          </div>

          <div class="form-group" [ngClass]="{ 'invalid': (rg.invalid && rg.touched) || (rg.invalid && f.submitted) }">
            <label for="rg">RG</label>
            <input type="text" class="form-control" id="rg" name="rg" [(ngModel)]="model.rg" #rg="ngModel" required>
          </div>

          <div class="form-group">
            <label for="email">Email</label>
            <input type="text" class="form-control" id="email" name="email" [(ngModel)]="model.email" #email="ngModel" pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$">
            <div *ngIf="email.errors && (email.invalid || email.touched)">
              <small class="text-danger" *ngIf="email.errors.pattern">Informe um email válido</small>
            </div>
          </div>

          <div class="form-group" [ngClass]="{ 'invalid': (phoneNumber.invalid && phoneNumber.touched) || (phoneNumber.invalid && f.submitted) }">
            <label for="phoneNumber">Telefone Celular</label>
            <input [textMask]="{mask: telefonemask}" placeholder="(__) _____-____" type="text" class="form-control" id="phoneNumber" name="phoneNumber" [(ngModel)]="model.phoneNumber" #phoneNumber="ngModel" required>
          </div>

          <div class="form-group" [ngClass]="{ 'invalid': (motherFullName.invalid && motherFullName.touched) || (motherFullName.invalid && f.submitted) }">
            <label for="motherFullName">Nome da Mãe</label>
            <input type="text" class="form-control" id="motherFullName" name="motherFullName" [(ngModel)]="model.motherFullName" #motherFullName="ngModel" required>
          </div>


          <div class="form-group" [ngClass]="{ 'invalid': (senha.invalid && senha.touched) || (senha.invalid && f.submitted) }">
            <label for="senha">Senha</label>
            <input type="password" class="form-control" id="senha" name="senha" placeholder="" [(ngModel)]="model.senha" #senha="ngModel" required>
          </div>

          <div class="form-group" [ngClass]="{ 'invalid': (csenha.invalid && csenha.touched) || (csenha.invalid && f.submitted) }">
            <label for="csenha">Confirma Senha</label>
            <input type="password" class="form-control" id="csenha" name="csenha" placeholder="" [(ngModel)]="model.csenha" #csenha="ngModel" required>
          </div>

          <div><span *ngIf="model.senha && model.csenha && model.senha.length >= 8 && model.csenha.length >= 8 && model.senha.length <= 20 && model.csenha.length <= 20">✔</span><span *ngIf="!(model.senha && model.csenha && model.senha.length >= 8 && model.csenha.length >= 8 && model.senha.length <= 20 && model.csenha.length <= 20)">❌</span> Sua senha deve ter entre 8 e 20 caracteres️</div>
          <div><span *ngIf="model.senha && model.csenha && testNumber(model.senha,model.csenha)">✔</span><span *ngIf="!(model.senha && model.csenha && testNumber(model.senha,model.csenha))">❌</span> Pelo menos um número️</div>
          <div><span *ngIf="model.senha && model.csenha && testLetter(model.senha,model.csenha)">✔</span><span *ngIf="!(model.senha && model.csenha && testLetter(model.senha,model.csenha))">❌</span> Pelo menos uma letra maiúscula ou minúscula</div>
          <div><span *ngIf="model.senha && model.csenha && testSpecial(model.senha,model.csenha)">✔</span><span *ngIf="!(model.senha && model.csenha && testSpecial(model.senha,model.csenha))">❌</span> Um caractere especial</div>
          <br>
          <div class="form-group" *ngIf="termsAcceptance != ''">
            <label>Termos de Aceite</label>
            <div class="form-check form-check-inline">
              <input class="form-check-input" name="termsAcceptance" type="checkbox" value=false [(ngModel)]="model.termsAcceptance" checked id="termsAcceptance">
              <label class="form-check-label" for="termsAcceptance">Eu aceito</label>
              <p class="caption" style="margin-left: 10px;"><a (click)="openModal(modalInfo)" href="javascript:void(0)" oncontextmenu="return false;">Leia os Termos de Aceite</a></p>
            </div>
          </div>

          <div class="form-group center">
            <re-captcha #rc (resolved)="resolved($event)" [siteKey]="reCaptchaKey" required></re-captcha>
          </div>

          <button type="submit" class="btn btn-primary btn-block mb-3" *ngIf="edit">Atualizar</button>
          <button type="submit" class="btn btn-primary btn-block mb-3" *ngIf="!edit">Cadastrar</button>
        </form>
      </div> <!-- /form-panel -->

    </div> <!-- /form -->
  </div> <!-- /row -->

  <ng-template #modalInfo let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modalInfoLabel">
          Termos de Aceite
        </h1>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
          </button>
    </div>
    <div class="modal-body">
        <p [innerHTML]="termsAcceptance"></p>
    </div>
</ng-template>

  <div class="row justify-content-center">
    <div class="col-4">

      <div class="row">
        <div class="col-lg-6">
          <a class="btn btn-link" [routerLink]="['/app/dashboard']" *ngIf="edit">Voltar</a>
          <a class="btn btn-link" [routerLink]="['/login']" *ngIf="!edit">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</div> <!-- /container -->
<!-- CADASTRO -->
